import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

@ngCore.Component({
  imports: [
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    ds.layout.widget.Component,
    ds.table.Component,
  ],
  selector: 'atn-dms-enum-page',
  standalone: true,
  styleUrls: ['./page.component.scss'],
  templateUrl: './page.component.html',
})
export class Component {
  /** @see {@link state.dms.enums.Collection} */
  private readonly _enumsEc = ngCore.inject(state.dms.enums.Collection)

  /** @see {@link state.dms.enumEntries.Collection} */
  public readonly enumEntriesEc = ngCore.inject(
    state.dms.enumEntries.Collection,
  )

  /** Canonical table input for the current enum's entries. */
  public readonly enumEntriesTableConfig = {
    collection: this.enumEntriesEc,
    view: {
      search: true,
      title: 'Entries',
    },
  } satisfies ds.table.ec.Config.Input<state.dms.enumEntries.TypeParams>

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Signal representing the current enum */
  public readonly enumSg =
    this._enumsEc.plugins.currentEntityPlugin.feature.selectors.getEntity()
      .asSignal

  /** Name of the current enum */
  public readonly enumNameSg = ngCore.computed(
    (current = this.enumSg()) => current?.name,
  )

  /** Description of the current enum */
  public readonly enumDescriptionSg = ngCore.computed(
    (current = this.enumSg()) => current?.description,
  )

  /** ID of the current enum */
  public readonly enumIdSg = ngCore.computed(
    (current = this.enumSg()) => current?.id,
  )

  /** Number of entries */
  public readonly entriesCountSg = ngCore.computed(
    (current = this.enumSg()) => current?.entries?.length ?? 0,
  )

  /** Breadcrumbs displayed in page header */
  public readonly breadcrumbsSg = ngCore.computed(
    () =>
      [
        {
          name: 'Catalog',
          url: this._meFeature.contexts.selectors
            .getUrlForLink({
              goto: {
                navigationId: ents.extra.prebuilt.AppPageAlias.Catalog,
              },
            })
            .asSignal(),
        },
        { name: this.enumNameSg() ?? '' },
      ] satisfies readonly ds.layout.page.child.header.models.Breadcrumb[],
  )
}
